import { render, staticRenderFns } from "./editResponsibility.vue?vue&type=template&id=cb9f02dc&"
import script from "./editResponsibility.vue?vue&type=script&lang=js&"
export * from "./editResponsibility.vue?vue&type=script&lang=js&"
import style0 from "./editResponsibility.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports